/** @prettier */
import { TestMode } from "../models";
import {
    API_ROOT,
    makeRequest,
    addParamsToUrl,
    PageParams,
} from "../../services/qbankApi";

const sortField = {
    name: "testName",
    mode: "testMode",
    createdDate: "created",
} as Record<string, string | undefined>;

type GetTestsResponse = {
    content: TestListData[];
    totalPages: number;
};

export async function getTests(
    userUuid: string,
    productId: string,
    params: PageParams,
) {
    // Change sort field to match value expected by the API
    //   Hopefully temporary.
    params.sortField = sortField[params.sortField!];
    const url = addParamsToUrl(
        `${API_ROOT}tests/users/${userUuid}/products/${productId}`,
        params,
    );

    const res = await (await makeRequest("GET", url)).json();
    return res as GetTestsResponse;
}

export type TestStatus = "OPEN" | "IN_PROGRESS" | "FINISHED";

export type TestListData = {
    uuid: string;
    createdDate: string;
    name: string;
    mode: TestMode;
    status: TestStatus;
    totalDurationInSeconds: number;
    timeLeftInSeconds: number;
    numQuestions: number;
    numCorrectQuestions: number;
    numAnsweredQuestions: number;
};

export async function renameTest(testUuid: string, newName: string) {
    const url = `${API_ROOT}tests/${testUuid}/updateParams`;
    await makeRequest("PATCH", url, {
        testName: newName,
    });
}
